import { HttpErrorResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';

import { ErrorUtils } from '@spaces-ui/utils';

import { MdwToastMessage } from './toast-message/toast-message';
import { ToastMessageConfig } from './toast-message-config';

@Injectable({ providedIn: 'root' })
export class MdwNotificationsService {
  private snackBar = inject(MatSnackBar);

  public showSuccess(
    message: string,
    duration = 3000,
    horizontalPosition: MatSnackBarHorizontalPosition = 'center',
    verticalPosition: MatSnackBarVerticalPosition = 'top',
  ) {
    const opts: ToastMessageConfig = {
      message,
      type: 'success',
    };

    this.snackBar.openFromComponent(MdwToastMessage, {
      data: opts,
      duration: duration,
      horizontalPosition: horizontalPosition,
      verticalPosition: verticalPosition,
    });
  }

  public showError(
    message: string,
    error?: string | HttpErrorResponse,
    duration = 3000,
    horizontalPosition: MatSnackBarHorizontalPosition = 'center',
    verticalPosition: MatSnackBarVerticalPosition = 'top',
  ) {
    const errorText =
      typeof error === 'string'
        ? error
        : error
          ? ErrorUtils.extractErrorMessage(error?.error ?? '')
          : undefined;
    const messageEndsInPeriodOrColon = message.endsWith('.') || message.endsWith(':');
    const messageWithError = errorText
      ? `${message}${messageEndsInPeriodOrColon ? '' : ':'} ${errorText}`
      : message;

    const opts: ToastMessageConfig = {
      message: messageWithError,
      type: 'error',
    };

    this.snackBar.openFromComponent(MdwToastMessage, {
      data: opts,
      duration: duration,
      horizontalPosition: horizontalPosition,
      verticalPosition: verticalPosition,
    });
  }
}
